// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type UseGlobalOptionTagsFilterQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.GlobalOptionTagsFilter>;
}>;


export type UseGlobalOptionTagsFilterQuery = { __typename?: 'Query', globalOptionTags: Array<{ __typename?: 'GlobalOptionTag', id: string, name: string }> };


export const UseGlobalOptionTagsFilterDocument = gql`
    query UseGlobalOptionTagsFilter($filter: GlobalOptionTagsFilter) {
  globalOptionTags(filter: $filter) {
    ...Named
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useUseGlobalOptionTagsFilterQuery__
 *
 * To run a query within a React component, call `useUseGlobalOptionTagsFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseGlobalOptionTagsFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseGlobalOptionTagsFilterQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUseGlobalOptionTagsFilterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UseGlobalOptionTagsFilterQuery, UseGlobalOptionTagsFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UseGlobalOptionTagsFilterQuery, UseGlobalOptionTagsFilterQueryVariables>(UseGlobalOptionTagsFilterDocument, options);
      }
export function useUseGlobalOptionTagsFilterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UseGlobalOptionTagsFilterQuery, UseGlobalOptionTagsFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UseGlobalOptionTagsFilterQuery, UseGlobalOptionTagsFilterQueryVariables>(UseGlobalOptionTagsFilterDocument, options);
        }
// @ts-ignore
export function useUseGlobalOptionTagsFilterSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UseGlobalOptionTagsFilterQuery, UseGlobalOptionTagsFilterQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UseGlobalOptionTagsFilterQuery, UseGlobalOptionTagsFilterQueryVariables>;
export function useUseGlobalOptionTagsFilterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UseGlobalOptionTagsFilterQuery, UseGlobalOptionTagsFilterQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UseGlobalOptionTagsFilterQuery | undefined, UseGlobalOptionTagsFilterQueryVariables>;
export function useUseGlobalOptionTagsFilterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UseGlobalOptionTagsFilterQuery, UseGlobalOptionTagsFilterQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UseGlobalOptionTagsFilterQuery, UseGlobalOptionTagsFilterQueryVariables>(UseGlobalOptionTagsFilterDocument, options);
        }
export type UseGlobalOptionTagsFilterQueryHookResult = ReturnType<typeof useUseGlobalOptionTagsFilterQuery>;
export type UseGlobalOptionTagsFilterLazyQueryHookResult = ReturnType<typeof useUseGlobalOptionTagsFilterLazyQuery>;
export type UseGlobalOptionTagsFilterSuspenseQueryHookResult = ReturnType<typeof useUseGlobalOptionTagsFilterSuspenseQuery>;
export type UseGlobalOptionTagsFilterQueryResult = ApolloReactCommon.QueryResult<UseGlobalOptionTagsFilterQuery, UseGlobalOptionTagsFilterQueryVariables>;